import gql from 'graphql-tag';

export default gql`
  query unreadMessagesCountQuery(
    $dialog: MongoID
    $dialogUsers: [MongoID]
    $course: MongoID
    $lesson: MongoID
    $isCommonDialog: Boolean
  ) {
    unreadMessagesCountQuery(
      dialog: $dialog
      dialogUsers: $dialogUsers
      course: $course
      lesson: $lesson
      isCommonDialog: $isCommonDialog
    )
  }
`;
